import { render, staticRenderFns } from "./QzGuanLixj.vue?vue&type=template&id=1f100c8f&scoped=true"
import script from "./QzGuanLixj.vue?vue&type=script&lang=js"
export * from "./QzGuanLixj.vue?vue&type=script&lang=js"
import style0 from "./QzGuanLixj.vue?vue&type=style&index=0&id=1f100c8f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f100c8f",
  null
  
)

export default component.exports